var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetStarted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 127,
    viewBox: "0 0 124 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9039 97.1051C91.35 97.1051 104.682 83.7728 104.682 67.3267C104.682 50.8806 91.35 37.5483 74.9039 37.5483C58.4577 37.5483 45.1255 50.8806 45.1255 67.3267C45.1255 83.7728 58.4577 97.1051 74.9039 97.1051Z",
    fill: "#34B778"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8935 90.7681C60.8935 90.7681 59.6025 97.699 54.9032 101.907C50.2038 106.115 43.5166 106.115 43.5166 106.115",
    stroke: "#34B778",
    strokeWidth: 5.19893,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8241 97.0059L67.2793 123.938",
    stroke: "#34B778",
    strokeWidth: 5.19893,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3147 64.901C87.853 64.901 97.2066 55.5473 97.2066 44.0091C97.2066 32.4708 87.853 23.1172 76.3147 23.1172C64.7765 23.1172 55.4229 32.4708 55.4229 44.0091C55.4229 55.5473 64.7765 64.901 76.3147 64.901Z",
    fill: "#34B778"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5564 37.8203C71.5285 37.8203 77.1806 32.1682 77.1806 25.196C77.1806 18.2238 71.5285 12.5718 64.5564 12.5718C57.5842 12.5718 51.9321 18.2238 51.9321 25.196C51.9321 32.1682 57.5842 37.8203 64.5564 37.8203Z",
    fill: "#34B778"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9027 24.2556C59.2637 24.2556 62.799 20.7203 62.799 16.3592C62.799 11.9982 59.2637 8.46289 54.9027 8.46289C50.5417 8.46289 47.0063 11.9982 47.0063 16.3592C47.0063 20.7203 50.5417 24.2556 54.9027 24.2556Z",
    fill: "#34B778"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5377 51.3608L62.7013 54.8511L56.3892 57.3512",
    stroke: "#1A237E",
    strokeWidth: 1.72369,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3211 53.4653L86.8853 56.3615L92.9251 59.4309",
    stroke: "#1A237E",
    strokeWidth: 1.72369,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.647 64.4302C70.3501 68.6878 79.7564 69.2323 84.4348 65.5441",
    stroke: "white",
    strokeWidth: 5.52528,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.925 67.9946C119.262 64.7767 124.237 49.5286 119.757 33.3398",
    stroke: "#34B778",
    strokeWidth: 5.19893,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3325 21.5327L34.1103 67.2523",
    stroke: "#EF81AC",
    strokeWidth: 3.09416,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9909 26.3835L18.8869 35.9135L15.8917 26.631L8.96074 33.4877L11.4856 24.0566L1.90601 26.0864L9.13401 19.5268L0 16.0613L9.62908 14.4276L3.81203 6.58072L12.7975 10.4175L12.1539 0.664651L17.6244 8.75902L22.3523 0.194336L22.5999 9.97194L31.1893 5.31829L26.1149 13.6849L35.8429 14.4276L27.0802 18.6851L34.8528 24.5765L25.1495 23.4378L28.5407 32.5966L20.9909 26.3835Z",
    fill: "#F9B067"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7744 78.3664C52.5764 75.297 27.6001 47.8455 26.6595 47.5979C25.7189 47.3256 29.2834 44.1324 28.6893 44.7513",
    stroke: "#34B778",
    strokeWidth: 5.19893,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/GetStarted.7e92d6992279238fa1ec4d841c7de6e7.svg";
export { ForwardRef as ReactComponent };